export default __webpack_public_path__ + "static/media/right-square-shape.d8d1f721.png";